export default "__VITE_ASSET__npQFnwlC__"